import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import requests from "../lib/requests";
import { useParams } from "react-router-dom";
import styles from "./WebhookLog.module.css";

const detailNames: any = {
  api: "API",
  created_at: "Creado en",
  format: "Formato",
  headers: "Encabezados de solicitud HTTP",
  id: "Identificación",
  lastsession: "Última sesión",
  method: "Method",
  name: "Nobmre",
  acctPwd: "Contraseña",
  priority: "Prioriy",
  queue: "Queue",
  schema: "Esquema de datos",
  url: "URL",
  username: "Nombre de usuario",
  webhook_for: "Wehook Para",
};

function JSONView({
  title,
  code,
  removeHeader = false,
}: PropsWithChildren<{
  title?: string;
  code: string;
  removeHeader?: boolean;
}>) {
  function tryJson() {
    try {
      return JSON.stringify(JSON.parse(code), undefined, 4);
    } catch (error) {
      return "";
    }
  }
  return (
    <div className={styles.codeBack}>
      {!removeHeader && <h3 className={styles.codeHeader}>{title}</h3>}
      <pre className={styles.code}>
        <code>{code && typeof code === "string" && tryJson()}</code>
      </pre>
    </div>
  );
}

function WebhookLog() {
  const param = useParams();
  const [detail, setDetail] = useState<any>({});
  const [logs, setLogs] = useState<any[] | null>([]);

  const fetchLogs = useCallback(async () => {
    try {
      const reqData = await requests.get(`/webhooks/${param.webhookId}/log`);
      setDetail(reqData.data.data);
      setLogs(reqData.data.data.logs);
    } catch (error) {
      setDetail({});
      setLogs([]);
    }
  }, []);

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", marginBottom: "20px" }}>
        <div style={{ display: "flex", flex: 1 }}>
          <div
            className={styles.codeBack}
            style={{ width: "100%", height: "auto" }}
          >
            <h2 className={styles.codeHeader}>Detalle de configuración</h2>
            <pre className={styles.code}>
              <ul>
                {Object.keys(detailNames).map(
                  (key: string, index) =>
                    detailNames[key] &&
                    ![" ", "null", "{}", "", "undefined"].includes(
                      String(detail[key])
                    ) && (
                      <li key={`${key}`}>
                        <span>{detailNames[key]}:</span>{" "}
                        <span>
                          {key == "acctPwd" ? (
                            <strong>{detail["password"]}</strong>
                          ) : (
                            <strong>{detail[key]}</strong>
                          )}
                        </span>
                      </li>
                    )
                )}
              </ul>
            </pre>

            <JSONView code={detail.schema} title="Schema" removeHeader={true} />
          </div>
        </div>
      </div>
      <div>
        <h2>Registros</h2>
      </div>
      {logs?.length && (
        <div>
          <JSONView
            code={logs?.[0].request_schema ?? "{}"}
            title="Esquema de datos"
          />
          <JSONView
            code={logs?.[0].request_data}
            title="Datos de solicitud HTTP"
          />
          <JSONView code={logs?.[0].status} title="Estado" />
          <JSONView code={logs?.[0].response_data} title="Datos de respuesta" />
        </div>
      )}
    </div>
  );
}

export default WebhookLog;
